
















































import { MessageDialog } from '../../utils/MessageDialog';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Session } from '../../utils/Session';
import { StudentService } from '../../biz/remote/StudentService';
import { StudentInfoInputDTO } from '../../../src_server/entity/dto/StudentInfoInputDTO';
import { Sorter } from '../../utils/Sorter';
import SortTh from '../../components/atoms/SortTh.vue';
import { URIs } from '../../../src_server/common/URIs';
import Axios from 'axios';

@Component({ components: { SortTh } })
export default class KaihipayUserCsvPage extends Vue {
  public viewCount = 10;

  private loading = false;
  private rows: StudentInfoInputDTO[] = [];
  private originalRows: StudentInfoInputDTO[] = [];

  sortBy(up: boolean, target: any) {
    this.rows = this.originalRows.sort(Sorter.compareByPath(target, up));
  }

  kpDownloaded(row: any) {
    row.student.kp_downloaded = row.student.kp_downloaded === 1 ? 0 : 0;
    MessageDialog.alert('alert' + row.student.kp_downloaded);
  }

  async created() {
    await this.loadData();
  }

  defaultChecked(row: StudentInfoInputDTO) {
    row.student.kp_downloaded = !!row.student.kp_downloaded;
    return !!row.student.kp_downloaded;
  }

  checked(row: StudentInfoInputDTO, event: any) {
    row.student.kp_downloaded = event.target.checked;
  }

  @Watch('isShowDownloaded')
  async loadData() {
    this.loading = true;
    const biz = new StudentService();
    const response = await biz.getKpCsvViewInitList(Session.getSessionBuildingId());
    this.originalRows = response.data;
    this.rows = this.originalRows.filter((r) => {
      this.loading = false;
      if (this.isShowDownloaded) {
        return true;
      } else {
        return !r.student.kp_downloaded;
      }
    });
    this.loading = false;
  }

  checkAll() {
    this.rows.forEach((d) => (d.student.kp_downloaded = true));
  }
  offAll() {
    this.rows.forEach((d) => (d.student.kp_downloaded = false));
  }

  async outCSV() {
    const selected_user_ids = this.rows.filter((d) => d.student.kp_downloaded).map((d) => d.student.user_id);
    const url = `${URIs.KP_USER_CSV_DOWNLOAD.path}?&building_id=${Session.getSessionBuildingId()}&selected=${selected_user_ids.join(',')}&token=${Session.getJwtToken()}`;
    const response = await Axios.get(url);
    // // console.log('tes', response.data);
    location.href = url;
  }

  private isShowDownloaded = false;
}
